import { SubscriptionManagerState } from './state';

export const subscriptionManagerInitialState: SubscriptionManagerState = {
  loaded: false,
};
